var Handlebars = require("../../../node_modules/.pnpm/handlebars@4.7.9_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression;

  return "<i class=\""
    + alias3(alias2(alias1(depth0, "icon_class", {"start":{"line":1,"column":12},"end":{"line":1,"column":22}} ), depth0))
    + "\" data-tippy-content=\""
    + alias3(alias2(alias1(depth0, "tooltip", {"start":{"line":1,"column":48},"end":{"line":1,"column":55}} ), depth0))
    + "\"></i>\n";
},"useData":true});